// extracted by mini-css-extract-plugin
export var blue = "_31-f";
export var brand = "_31-b";
export var darkGrey = "_31-e";
export var disabled = "_31-4";
export var disabledSubtle = "_31-5";
export var error = "_31-6";
export var green = "_31-g";
export var grey = "_31-d";
export var icon = "_31-0";
export var inherit = "_31-a";
export var lightGrey = "_31-c";
export var orange = "_31-i";
export var pink = "_31-k";
export var primary = "_31-1";
export var purple = "_31-l";
export var red = "_31-j";
export var secondary = "_31-2";
export var success = "_31-9";
export var tertiary = "_31-3";
export var warning = "_31-7";
export var warningSecondary = "_31-8";
export var white = "_31-m";
export var yellow = "_31-h";